import { AnimatePresence, motion } from 'motion/react';
import { BagScanContextProvider, BagScanPageType } from './context';
import { BagScanErrorHandler } from './error-handler';
import { useBagScanContext } from './hook';
import { BagScanEvaluateBagPage } from './subroutes/evaluate-bag';
import { BagScanManualCodeEntryPage } from './subroutes/manual-code-entry';
import { BagScanScanPage } from './subroutes/scan';

export const FacilityBagScanPage = () => {
	return (
		<BagScanContextProvider>
			<BagScanPageRoot />
		</BagScanContextProvider>
	);
};

const BagScanPageRoot = () => {
	return (
		<>
			<AnimatePresence>
				<SubRoute id="SCAN" component={<BagScanScanPage />} />
				<SubRoute id="MANUAL" component={<BagScanManualCodeEntryPage />} />
				<SubRoute id="EVALUATE" component={<BagScanEvaluateBagPage />} />
			</AnimatePresence>
			<BagScanErrorHandler />
		</>
	);
};

const SubRoute = ({ id, component }: { id: BagScanPageType; component: React.ReactNode }) => {
	const { page } = useBagScanContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
